import { setSession } from "@/shared/redux/reducers/authSlice";

import { CAR_QUOTE_STEP_KEYS } from "@/D2C/features/car-quote/common/static";
import { saveCarQuoteStepFor } from "@/D2C/features/car-quote/redux/car-quote/carQuoteSlice";

import { TRAVEL_QUOTE_STEP_KEYS } from "@/D2C/features/travel-quote/common/static";
import { saveTravelQuoteStepFor } from "@/D2C/features/travel-quote/redux/travel-quote/travelQuoteSlice";

import { HEALTH_QUOTE_STEP_KEYS } from "@/D2C/features/health-quote/common/static";
import { saveHealthQuoteStepFor } from "@/D2C/features/health-quote/redux/health-quote/healthQuoteSlice";

import { getLobIdByName } from "@/shared/common/static";

import { setSharedPersonalDetails } from "@/shared/redux/reducers/personalDetailsSlice";

import {
  setQuoteFlowQuoteData,
  setQuoteFlowSessionData,
} from "@/shared/redux/reducers/quoteFlowSlice";

import {
  buildResumeTargetPath,
  hydrateResumeJourneyState,
  type ResumeSessionResponse,
} from "@/D2C/features/auth/utils/resumeJourney";

export const dispatchResumeJourney = (dispatch: any, sessionData: ResumeSessionResponse) => {
  const resumeState = hydrateResumeJourneyState(sessionData);

  dispatch(setSession(resumeState.quoteFlow.sessionData));

  dispatch(setSharedPersonalDetails(resumeState.sharedPersonalDetails));

  dispatch(setQuoteFlowSessionData(resumeState.quoteFlow.sessionData));

  dispatch(setQuoteFlowQuoteData(resumeState.quoteFlow.quoteData));

  if (resumeState.lobId === getLobIdByName("motor") && resumeState.car) {
    dispatch(
      saveCarQuoteStepFor(CAR_QUOTE_STEP_KEYS.PERSONAL_DETAILS, resumeState.car.personalDetails)
    );

    dispatch(
      saveCarQuoteStepFor(CAR_QUOTE_STEP_KEYS.VEHICLE_DETAILS, resumeState.car.vehicleDetails)
    );

    dispatch(
      saveCarQuoteStepFor(CAR_QUOTE_STEP_KEYS.DRIVER_DETAILS, resumeState.car.driverDetails)
    );

    dispatch(
      saveCarQuoteStepFor(CAR_QUOTE_STEP_KEYS.QUOTE_SELECTION, resumeState.car.quoteSelection)
    );

    dispatch(
      saveCarQuoteStepFor(CAR_QUOTE_STEP_KEYS.DOCUMENT_UPLOAD, resumeState.car.documentUpload)
    );

    dispatch(
      saveCarQuoteStepFor(CAR_QUOTE_STEP_KEYS.ADDITIONAL_INFO, resumeState.car.additionalInfo)
    );

    dispatch(saveCarQuoteStepFor(CAR_QUOTE_STEP_KEYS.PAYMENT, resumeState.car.payment));
  }

  if (resumeState.lobId === getLobIdByName("travel") && resumeState.travel) {
    dispatch(
      saveTravelQuoteStepFor(
        TRAVEL_QUOTE_STEP_KEYS.PERSONAL_DETAILS,
        resumeState.travel.personalDetails
      )
    );

    dispatch(
      saveTravelQuoteStepFor(
        TRAVEL_QUOTE_STEP_KEYS.TRAVEL_DETAILS,
        resumeState.travel.travelDetails
      )
    );

    dispatch(
      saveTravelQuoteStepFor(
        TRAVEL_QUOTE_STEP_KEYS.QUOTE_SELECTION,
        resumeState.travel.quoteSelection
      )
    );

    dispatch(
      saveTravelQuoteStepFor(
        TRAVEL_QUOTE_STEP_KEYS.DOCUMENT_UPLOAD,
        resumeState.travel.documentUpload
      )
    );

    dispatch(
      saveTravelQuoteStepFor(
        TRAVEL_QUOTE_STEP_KEYS.ADDITIONAL_INFO,
        resumeState.travel.additionalInfo
      )
    );

    dispatch(saveTravelQuoteStepFor(TRAVEL_QUOTE_STEP_KEYS.PAYMENT, resumeState.travel.payment));
  }

  if (resumeState.lobId === getLobIdByName("health") && resumeState.health) {
    dispatch(
      saveHealthQuoteStepFor(
        HEALTH_QUOTE_STEP_KEYS.PERSONAL_DETAILS,
        resumeState.health.personalDetails
      )
    );

    dispatch(
      saveHealthQuoteStepFor(
        HEALTH_QUOTE_STEP_KEYS.HEALTH_DETAILS,
        resumeState.health.healthDetails
      )
    );

    dispatch(
      saveHealthQuoteStepFor(HEALTH_QUOTE_STEP_KEYS.HEALTH_HABITS, resumeState.health.healthHabits)
    );

    dispatch(
      saveHealthQuoteStepFor(
        HEALTH_QUOTE_STEP_KEYS.QUICK_QUESTIONS,
        resumeState.health.quickQuestions
      )
    );

    dispatch(
      saveHealthQuoteStepFor(
        HEALTH_QUOTE_STEP_KEYS.QUOTE_SELECTION,
        resumeState.health.quoteSelection
      )
    );

    dispatch(
      saveHealthQuoteStepFor(
        HEALTH_QUOTE_STEP_KEYS.DOCUMENT_UPLOAD,
        resumeState.health.documentUpload
      )
    );

    dispatch(
      saveHealthQuoteStepFor(
        HEALTH_QUOTE_STEP_KEYS.ADDITIONAL_INFO,
        resumeState.health.additionalInfo
      )
    );

    dispatch(saveHealthQuoteStepFor(HEALTH_QUOTE_STEP_KEYS.PAYMENT, resumeState.health.payment));
  }

  return {
    resumeState,
    targetPath: buildResumeTargetPath(resumeState.target),
  };
};
